"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var dateTime_styles_1 = require("./dateTime.styles");
var dateTimeStore_1 = require("../../../util/datetime/dateTimeStore");
var dateTimeFormatter_1 = require("../../../util/formatting/dateTimeFormatter");
exports.FormatDateTime = function (props) {
    var dateandtime = dateTimeStore_1.DateAndTimeStore.getInstance();
    var spaceDate, date, time;
    if (props.epoch) {
        spaceDate = dateandtime.getDateTimeForTimezoneFromEpochSeconds(props.epoch);
        date = dateTimeFormatter_1.customLocale(spaceDate, props.language, {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        });
        time = dateTimeFormatter_1.customLocale(spaceDate, props.language, { hour: "2-digit", minute: "2-digit" });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { id: props.id + "-date-value" }, props.epoch && date !== "" && date !== undefined ? (date) : (react_1.default.createElement("div", { className: dateTime_styles_1.placeholder }, "\u00A0"))),
        react_1.default.createElement("span", { id: props.id + "-time-value", className: dateTime_styles_1.timeValue }, props.epoch && time !== "" && time !== undefined ? (time) : (react_1.default.createElement("div", { className: dateTime_styles_1.placeholder }, "\u00A0")))));
};
